import{a as e}from"./chunk-YSXGDEY5.mjs";import{WalletClientBase as o}from"@goat-sdk/core";var s=class extends o{static{e(this,"EVMWalletClient")}};export{s as a};
